import { SectionHeader } from '#/components/ui/SectionHeader';
import type { CategoryLearningView } from '#/content/category';

interface LearningSectionProps {
  content: CategoryLearningView;
}

/**
 * The learning component: a light-blue panel with a centered header and up to
 * three columns of title + text flowing in below it. Rendered only when the
 * `information` list has content — the caller drops it otherwise.
 */
export function LearningSection({ content }: LearningSectionProps) {
  const { header, columns } = content;

  return (
    <section
      id="learning"
      className="bg-blue-10 flow flow-inner-32 scroll-mt-(--scroll-offset) rounded p-32"
    >
      <SectionHeader
        title={header.title}
        accentVariant="short"
        contentAlignment="center"
      >
        <p className="text-fg-muted text-fluid-base-sm leading-relaxed">
          {header.text}
        </p>
      </SectionHeader>

      {columns.length > 0 && (
        <div className="border-blue-30 grid gap-24 border-t pt-32 lg:grid-cols-3 lg:gap-32">
          {columns.map((column) => (
            <div key={column.title} className="flow flow-8">
              <h3 className="text-fg-strong text-fluid-base-sm font-semibold">
                {column.title}
              </h3>
              <p className="text-fg-muted text-static-14 leading-relaxed">
                {column.text}
              </p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
